/**
 * Night Mode - Static track catalog
 * All tracks stored in R2 under night/ prefix
 * free: true = available for free users
 */

const NIGHT_CATEGORIES = [
  {
    id: 'appliances',
    labelFr: 'Appareils',
    labelEn: 'Appliances',
    free: true,
    tracks: [
      { id: 'airplane_cabin', file: 'airplane_cabin.m4a', r2cat: 'night_appliances', labelFr: 'Cabine d\'avion', labelEn: 'Airplane Cabin', free: true },
      { id: 'ceiling_fan', file: 'ceiling_fan.m4a', r2cat: 'night_appliances', labelFr: 'Ventilateur', labelEn: 'Ceiling Fan', free: true },
      { id: 'air_conditioner', file: 'air_conditioner.m4a', r2cat: 'night_appliances', labelFr: 'Climatisation', labelEn: 'Air Conditioner', free: true },
    ],
  },
  {
    id: 'nature',
    labelFr: 'Nature',
    labelEn: 'Nature',
    free: false,
    tracks: [
      { id: 'forest_river', file: 'forest_river.m4a', r2cat: 'night_nature', labelFr: 'Riviere en foret', labelEn: 'Forest River', free: false },
      { id: 'light_rain', file: 'light_rain.m4a', r2cat: 'night_nature', labelFr: 'Pluie legere', labelEn: 'Light Rain', free: false },
    ],
  },
  {
    id: 'atmospheres',
    labelFr: 'Atmospheres',
    labelEn: 'Atmospheres',
    free: false,
    tracks: [
      { id: 'deep_atmosphere', file: 'deep_atmosphere.m4a', r2cat: 'night_pads', labelFr: 'Atmosphere profonde', labelEn: 'Deep Atmosphere', free: false },
      { id: 'warm_air', file: 'warm_air.m4a', r2cat: 'night_pads', labelFr: 'Air chaud', labelEn: 'Warm Air', free: false },
      { id: 'nocturnal_space', file: 'nocturnal_space.m4a', r2cat: 'night_pads', labelFr: 'Espace nocturne', labelEn: 'Nocturnal Space', free: false },
    ],
  },
];

export default NIGHT_CATEGORIES;
